import { string, shape, arrayOf, object } from 'prop-types';
//TODO: move to polymer
export default shape({
  title: string.isRequired,
  description: string,
  template: string.isRequired,
  fields: arrayOf(
    shape({
      label: string.isRequired,
      key: string.isRequired,
      validationConstraints: object,
      type: string.isRequired
    })
  )
});
